<template>
  <div class="w-[500px] bg-white shadow-sm">
    <div class="p-12 mb-4">
      <AppImgPlaceholder
        :src="plan.logo"
        class="w-28 ml-auto mb-4 aspect-square"
      />

      <h1 class="font-bold text-[30pt] leading-[1.1] mb-4">
        {{ plan.municipality.name }}
      </h1>

      <h2 class="text-[20pt] font-bold leading-[1.1]">
        Integrated Development Plan
      </h2>

      <h2 class="text-[20pt] font-bold mb-2">
        {{ planDuration }}
      </h2>

      <h3 class="text-[15pt] text-black font-medium mb-2">
        {{ plan.subtitle }}
      </h3>

      <span class="text-xs text-black font-medium">
        Last Published: {{ formatShortDate(plan.lastPublishedAt) || 'N/A' }}
      </span>
    </div>

    <div class="flex full-width">
      <div
        v-for="color in ['bg-black', 'bg-green-700', 'bg-orange-700', 'bg-blue-700', 'bg-yellow-400']"
        :key="color"
        :class="color"
        class="h-2 flex-1"
      />
    </div>

    <AppImgPlaceholder
      :src="plan.coverPageImage"
      class="w-full h-48 [&_img]:object-cover"
    />
  </div>
</template>

<script setup>
import { planDuration } from '@/const';
import { useDateFormatter } from '@/composables';
import { AppImgPlaceholder } from '@/components/app';

const { formatShortDate } = useDateFormatter();

defineProps({
  plan: {
    type: Object,
    required: true,
  },
});
</script>
